import { render, staticRenderFns } from "./SectionsReorderLayout.vue?vue&type=template&id=1e82cf24&scoped=true"
import script from "./SectionsReorderLayout.vue?vue&type=script&lang=js"
export * from "./SectionsReorderLayout.vue?vue&type=script&lang=js"
import style0 from "./SectionsReorderLayout.vue?vue&type=style&index=0&id=1e82cf24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e82cf24",
  null
  
)

export default component.exports